import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'displayValue',
  standalone: true,
  pure: false,
})
export class DisplayValuePipe implements PipeTransform {
  private translationService = inject(TranslationService);

  transform(value: unknown): unknown {
    if (value === null || value === undefined) {
      return this.translationService.translate('common.notProvided');
    }
    if (typeof value === 'string') {
      const normalized = value.trim();
      if (!normalized || /^[-—–]+$/.test(normalized)) {
        return this.translationService.translate('common.notProvided');
      }
    }
    return value;
  }
}
